import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção dos demais relatórios PJ). */
export type ReciboProtocoloPjJob = ReportJob;
export type ReciboProtocoloPjJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) do Recibo de Protocolo. */
@Injectable({ providedIn: 'root' })
export class ReciboProtocoloPjJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'recibo-protocolo-pj-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.prestador.reports.reciboProtocoloPj;
}
